import { gql, useQuery } from '@apollo/client';
import {
  CSGetDocumentAnalysisByEntityStatus,
  DocumentAnalysis,
  documentAnalysisByFirmStatus,
  DocumentAnalysisStatus,
  ModelSortDirection,
} from '@admiin-com/ds-graphql';

export type DocumentAnalysisSortBy = 'createdAt' | 'updatedAt';
interface UseDocumentAnalysisProps {
  entityId?: string;
  firmId?: string | null;
  status?: DocumentAnalysisStatus;
  skip?: boolean;
  source?: 'EMAIL' | 'XERO';
  limit?: number;
  nextToken?: string;
  sortDirection?: ModelSortDirection;
  sortBy?: DocumentAnalysisSortBy;
  createdBy?: string;
}

export const useDocumentAnalysisByEntityStatus = ({
  entityId,
  status = DocumentAnalysisStatus.SCANNED,
  skip = false,
  source,
  limit,
  nextToken,
  sortDirection = ModelSortDirection.DESC,
}: UseDocumentAnalysisProps) => {
  const { data, loading, error, refetch } = useQuery(
    gql(CSGetDocumentAnalysisByEntityStatus),
    {
      variables: {
        entityId,
        status,
        limit,
        nextToken,
        sortDirection,
        // sortBy,
      },
      skip: skip || !entityId,
    }
  );

  let documentAnalysis = [
    ...(data?.documentAnalysisByEntityStatus?.items ?? []),
  ];

  if (source) {
    documentAnalysis = documentAnalysis.filter(
      (item: DocumentAnalysis) => item.source === source
    );
  }

  return {
    documentAnalysis,
    nextToken: data?.documentAnalysisByEntityStatus?.nextToken,
    loading,
    error,
    refetch: () => refetch({ fetchPolicy: 'no-cache' }),
  };
};

export const useDocumentAnalysisByFirmStatus = ({
  firmId,
  status = DocumentAnalysisStatus.SCANNED,
  skip = false,
  source,
  limit,
  nextToken,
  sortDirection = ModelSortDirection.DESC,
  createdBy,
}: UseDocumentAnalysisProps) => {
  const { data, loading, error, refetch } = useQuery(
    gql(documentAnalysisByFirmStatus),
    {
      variables: {
        firmId,
        status,
        createdBy,
        limit,
        nextToken,
        sortDirection,
      },
      skip: skip || !firmId,
    }
  );

  let documentAnalysis = [...(data?.documentAnalysisByFirmStatus?.items ?? [])];

  if (status) {
    documentAnalysis = documentAnalysis.filter(
      (item: DocumentAnalysis) => item.status === status
    );
  }

  if (source) {
    documentAnalysis = documentAnalysis.filter(
      (item: DocumentAnalysis) => item.source === source
    );
  }

  return {
    documentAnalysis,
    nextToken: data?.documentAnalysisByFirmStatus?.nextToken,
    loading,
    error,
    refetch: () => refetch({ fetchPolicy: 'no-cache' }),
  };
};
